<template>
  <div class="headbar" :style="{'background':themeColor}"
    :class="$store.state.app.collapse?'position-collapse-left':'position-left'">
    <!-- 导航收缩 -->
    <span class="hamburg">
      <el-menu class="el-menu-demo" :background-color="themeColor" text-color="#fff" :active-text-color="themeColor" mode="horizontal">
        <el-menu-item index="1" @click="onCollapse"><hamburger :isActive="collapse"></hamburger></el-menu-item>
      </el-menu>
    </span>
    <!-- 导航菜单 -->
    <!--<span class="navbar">-->
    <!--  <el-menu :default-active="activeIndex" class="el-menu-demo"-->
    <!--      :background-color="themeColor" text-color="#fff" active-text-color="#ffd04b" mode="horizontal" @select="selectNavBar()">-->
    <!--    <el-menu-item index="1" @click="$router.push('/')"><i class="fa fa-home fa-lg"></i>  </el-menu-item>-->
    <!--    <el-menu-item index="2" @click="openWindow('https://gitee.com/liuge1988/XYJ')">{{$t("common.projectRepo")}}</el-menu-item>-->
    <!--    <el-menu-item index="3" @click="openWindow('https://gitee.com/liuge1988/XYJ/wikis/Home')">{{$t("common.doc")}}</el-menu-item>-->
    <!--    <el-menu-item index="4" @click="openWindow('https://www.cnblogs.com/xifengxiaoma/')">{{$t("common.blog")}}</el-menu-item>-->
    <!--  </el-menu>-->
    <!--</span>-->
    <!-- 工具栏 -->
    <span class="toolbar">
      <el-menu class="el-menu-demo" :background-color="themeColor" :text-color="themeColor" :active-text-color="themeColor" mode="horizontal">
      	<el-menu-item index="6" v-if="control == 1">
           <!--聊天-->
            <el-badge :value="value" class="item" :hidden="value == 0 || value < 0">
						  <el-button class="fa fa-comments-o" type="text" @click="chat = !chat;$refs.vuechart.FriendList()" style="color: #fff;font-size: 20px;"></el-button>
						</el-badge>
        </el-menu-item>
        <el-menu-item index="1">
           <!--主题切换-->
          <theme-picker class="theme-picker" :default="themeColor" @onThemeChange="onThemeChange"></theme-picker>
        </el-menu-item>
        <el-menu-item index="2" v-popover:popover-lang>
           <!--语言切换-->
          <li style="color:#fff;" class="fa fa-language fa-lg"></li>
          <el-popover ref="popover-lang" placement="bottom-start" trigger="click" v-model="langVisible">
            <div class="lang-item" @click="changeLanguage('zh_cn')">简体中文</div>
            <div class="lang-item" @click="changeLanguage('en_us')">English</div>
          </el-popover>
        </el-menu-item>

        <el-menu-item index="5" v-popover:popover-personal>
          <!-- 用户信息 -->
         <span class="user-info">
           <!-- <img :src="user.avatar" /> -->
           {{user.name}}</span>
          <el-popover ref="popover-personal" placement="bottom-end" trigger="click" :visible-arrow="false">
            <personal-panel :user="user"></personal-panel>
          </el-popover>
        </el-menu-item>
      </el-menu>
    </span>
    <div v-if="control == 1">
      <vue-chart v-show="chat" ref="vuechart" @updatebadge="isRead()" @isRead="isRead()"></vue-chart>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Hamburger from "@/components/Hamburger"
import ThemePicker from "@/components/ThemePicker"
import LangSelector from "@/components/LangSelector"
import Action from "@/components/Toolbar/Action"
import NoticePanel from "@/views/Core/NoticePanel"
import MessagePanel from "@/views/Core/MessagePanel"
import PersonalPanel from "@/views/Core/PersonalPanel"
import VueChart from "@/components/vueChart/index"
export default {
  components:{
        Hamburger,
        ThemePicker,
        LangSelector,
        Action,
        NoticePanel,
        MessagePanel,
        PersonalPanel,
        VueChart
  },
  data() {
    return {
      user: {
        name: "Louis",
        avatar: "",
        role: "超级管理员",
        registeInfo: "注册时间： "+sessionStorage.getItem('createTime')
      },
      activeIndex: '1',
      langVisible: false,
      chat:false,
      value:0,
      hidden:true,
      control:sessionStorage.getItem("chat_funciton")
    }
  },
  watch:{
    control(val){
      this.control = val
    }
  },
  methods: {
    openWindow(url) {
      window.open(url)
    },
    selectNavBar(key, keyPath) {
      console.log(key, keyPath)
    },
    // 折叠导航栏
    onCollapse: function() {
      this.$store.commit('onCollapse')
    },
    // 切换主题
    onThemeChange: function(themeColor) {
      this.$store.commit('setThemeColor', themeColor)
    },
    // 语言切换
    changeLanguage(lang) {
      lang === '' ? 'zh_cn' : lang
      this.$i18n.locale = lang
      this.langVisible = false
    },
    open(){
    	this.$refs.vuechart.open()
    },
    isRead(){
    	this.$api.im.HistoryQuery({
        pageBean:{
          page:1,
          pageSize:1000
        },
	      querys: [
	        {
	          "hasInitValue": true,
	          "operation": "EQUAL",
	          "property": "tochatid",
	          "relation": "AND",
	          "value": sessionStorage.getItem('chatid')
	        },
	        {
	          "hasInitValue": true,
	          "operation": "EQUAL",
	          "property": "alreadyread",
	          "relation": "AND",
	          "value": 0
	        }
	      ]
	    }).then((res)=>{
	      if(res.data.rows.length>0) {
          this.value = res.data.rows.length;
          this.hidden = false;
        }else{
          this.value = 0;
          this.hidden = true;
        }
	    }).catch((error)=>{
	      this.$message.error(error.message);
	    })
    }
  },
  mounted() {
    this.sysName = "xyj Platform"
    var user = sessionStorage.getItem("user")
    if (user) {
      this.user.name = user
      this.user.avatar = require("@/assets/my1.png")
    }
    sessionStorage.getItem("chat_funciton")==1 && this.isRead()
  },
  computed:{
    ...mapState({
      themeColor: state=>state.app.themeColor,
      collapse: state=>state.app.collapse
    })
  }
}
</script>

<style scoped lang="scss">
.headbar {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1030;
  height: 60px;
  line-height: 60px;
  border-color: rgba(180, 190, 190, 0.8);
  border-left-width: 1px;
  border-left-style: solid;
}
.hamburg, .navbar {
  float: left;
}
.toolbar {
  float: right;
}
.lang-item {
  font-size: 16px;
  padding-left: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
}
.lang-item:hover {
  font-size: 18px;
  background: #b0d6ce4d;
}
.user-info {
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  img {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    margin: 10px 0px 10px 10px;
    float: right;
  }
}
.badge {
  line-height: 18px;
}
.position-left {
  left: 200px;
  border: none;
}
.position-collapse-left {
  left: 65px;
}
.item /deep/ .el-badge__content{
	top: 15px!important;
}
</style>



// WEBPACK FOOTER //
// src/views/HeadBar/HeadBar.vue